<template>
    <div class="main_view_container">
        <section
            v-if="
                App.root_activated_view !==
                'single_application_solution'
            "
            class="lateral_block"
        >
            <comp_lateral_menu></comp_lateral_menu>
        </section>
        <section class="main_block">
            <comp_menu_lang></comp_menu_lang>
            <div clasS="main_block_container">
                <view_app_selector
                    activated_view="dashboard"
                ></view_app_selector>
            </div>
        </section>
    </div>
</template>

<script>
import comp_lateral_menu from './comp_lateral_menu.vue'
import comp_menu_lang from './comp_menu_lang.vue'
import view_app_selector from './view_app_selector.vue'
import App from './../application.js'

export default {
    components: {
        comp_lateral_menu,
        comp_menu_lang,
        view_app_selector
    },
    data: function(){
        return {
            App: App
        }
    }
}
</script>